// extracted by mini-css-extract-plugin
module.exports = {"form":"QuoteForm_form__3Ndw9","loading":"QuoteForm_loading__iDpS0","control":"QuoteForm_control__2lCiE","actions":"QuoteForm_actions__354La"};